import { APP_INITIALIZER, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
  PreloadAllModules,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicStorageModule } from '@ionic/storage-angular';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { tokenInterceptor } from './app/core/interceptors/token.interceptor';
import { errorInterceptor } from './app/core/interceptors/error.interceptor';
import { StorageService } from './app/core/services/storage.service';
import { InventaireService } from './app/core/services/inventaire.service';
import { AuthService } from './app/core/auth/auth.service';

registerLocaleData(localeFr);

bootstrapApplication(AppComponent, {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({ mode: 'md' }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(
      withInterceptors([tokenInterceptor, errorInterceptor])
    ),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideAnimations(),
    {
      provide: APP_INITIALIZER,
      useFactory:
        (storage: StorageService, inventaire: InventaireService, auth: AuthService) => async () => {
          await storage.init();
          await auth.tryRestoreSession();
          await inventaire.loadFromStorage();
        },
      deps: [StorageService, InventaireService, AuthService],
      multi: true,
    },
  ],
});
